import React, { FC } from "react";
import Modal from "Components/Modal/Modal";
import ScheduleResourceForm from "./ScheduleResourceForm";
import { useScheduleResourceModal } from "./hooks/useScheduleResourceModal";

const ScheduleResourceModal: FC = () => {
	const isModalOpen = useScheduleResourceModal((state) => state.isOpen);
	const scheduleResource = useScheduleResourceModal((state) => state.item);

	if (isModalOpen && scheduleResource) {
		return (
			<Modal modalController={useScheduleResourceModal.getState()}>
				<ScheduleResourceForm scheduleResource={scheduleResource} />
			</Modal>
		);
	} else {
		return null;
	}
};

export default ScheduleResourceModal;
